import { FormInstance } from "antd";
import { FC } from "react";
import OrganizationSelectionSetting from "../OrganizationSelectionSetting";
type PropsType = {
  form: FormInstance;
  getFieldClassName?: (name: string) => string;
};

const DepartmentSelectionSetting: FC<PropsType> = ({
  form,
  getFieldClassName,
}) => {
  return (
    <OrganizationSelectionSetting
      form={form}
      modelName="department"
      getFieldClassName={getFieldClassName}
    />
  );
};

export default DepartmentSelectionSetting;
